import React, { useState, useContext, useLayoutEffect } from "react";
import ApiFile from "../../../app/api/admin/file/ApiFile";
import Page from "../../modules/page";
import { ContextContent } from "../../modules/content/contentContext";
import InputWrapper from "../../components/input/__wrapper";
import InputText from "../../components/inputs/text";
import InputFile from "../../components/inputs/file";
import InputDatetime from "../../components/inputs/datetime/datetime";
import FileLib from "../../../inc/FileLib";

// Карточка APK: show / edit / create одним компонентом (режим — contextContent.type).
// withDestroy={false} — удаления файлов в API нет (см. FilesController).
export default function FileShow({ ...other }) {
    return <Page ApiModel={ApiFile} withDestroy={false} {...other}>
        <FileShowContent/>
    </Page>;
}

function FileShowContent() {
    const contextContent = useContext(ContextContent);

    const [_id, set_id] = useState('');
    const [_name, set_name] = useState('');
    const [_file, set_file] = useState(null);
    const [_typeFile, set_typeFile] = useState('');
    // Версия приложения у APK (versionName) — только показ: бэкенд считает её при загрузке и замене.
    const [_version, set_version] = useState(null);
    const [_dir, set_dir] = useState('');
    const [_size, set_size] = useState(null);
    const [_publicUrl, set_publicUrl] = useState('');
    const [_created, set_created] = useState(null);
    const [_updated, set_updated] = useState(null);

    // На update оба поля необязательны по отдельности: пустое имя/непереложенный файл
    // просто не попадут в FormData (см. ApiFile.getParamsForStore).
    contextContent._dataToServer.current = {
        name: _name,
        file: _file,
    };

    useLayoutEffect(() => {
        contextContent._handleSetData.current = (data) => {
            set_id(data.id);
            set_name(data.name ?? '');
            set_file(null); // отмена редактирования сбрасывает выбранный файл
            set_typeFile(data.type_file ?? '');
            set_version(data.version ?? null);
            set_dir(data.dir ?? '');
            set_size(data.size ?? null);
            set_publicUrl(data.public_url ?? '');
            // Даты приходят только на *.show (BaseResource::isDetailed): в compact-ответе
            // update их нет — это «не прислали», а не «стало пусто», поэтому не затираем.
            set_created((previous) => data.created_at ?? previous);
            set_updated((previous) => data.updated_at ?? previous);
            contextContent.setTitle(`Файл: ${data.name}`);
        };
        if (contextContent.isCreate) contextContent.setTitle('Загрузка APK');
        contextContent.doLoad();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Имя = имя файла на диске, поэтому при создании подставляем его из выбранного APK,
    // но не затираем то, что уже ввели руками.
    const handleChangeFile = (event) => {
        const file = event.target.files[0] ?? null;
        set_file(file);
        if (file && !_name) set_name(file.name);
    };

    const readOnly = !contextContent.isCreateOrEdit;
    const errors = contextContent.errors ?? {};

    return <>
        {!contextContent.isCreate ?
            <InputWrapper>
                <InputText className="input_wf" value={_id} readOnly={true}>id</InputText>
            </InputWrapper> : null}

        <InputWrapper>
            <InputText className="input_wf" value={_name} readOnly={readOnly} errors={errors.name}
                placeholder="напр. app-release.apk"
                onChange={(e) => set_name(e.target.value)}>Имя файла</InputText>
        </InputWrapper>

        {contextContent.isCreateOrEdit ?
            <InputWrapper>
                <InputFile className="input_wf" value={_file} errors={errors.file} accept=".apk"
                    onChange={handleChangeFile}>
                    {contextContent.isCreate ? 'APK' : 'APK (пусто — оставить прежний)'}
                </InputFile>
            </InputWrapper> : null}

        {!contextContent.isCreate ? <>
            <InputWrapper>
                <InputText className="input_wf" value={FileLib.formatterSize(_size) ?? 'файл на диске не найден'} readOnly={true}>Размер</InputText>
            </InputWrapper>
            <InputWrapper>
                <InputText className="input_wf" value={_typeFile} readOnly={true}>Тип</InputText>
            </InputWrapper>
            {_version ? <InputWrapper>
                <InputText className="input_wf" value={_version} readOnly={true}>Версия</InputText>
            </InputWrapper> : null}
            <InputWrapper>
                <InputText className="input_wf" value={_dir} readOnly={true}>Каталог</InputText>
            </InputWrapper>
            <InputWrapper>
                <InputText className="input_wf" value={_publicUrl} readOnly={true}>Публичная ссылка</InputText>
            </InputWrapper>
            <InputWrapper>
                <InputDatetime className="input_wf" value={_created} readOnly={true}>Создан</InputDatetime>
            </InputWrapper>
            <InputWrapper>
                <InputDatetime className="input_wf" value={_updated} readOnly={true}>Обновлён</InputDatetime>
            </InputWrapper>
        </> : null}
    </>;
}
